import script from "./companyNews.vue?vue&type=script&setup=true&lang=js"
export * from "./companyNews.vue?vue&type=script&setup=true&lang=js"

import "./companyNews.vue?vue&type=style&index=0&id=1e59a5d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e59a5d8"]])

export default __exports__